import AxiosConfig from '../config/axios-config'

export default {

  registrarClique (event, sourceSystem, sourceUrl, userEmail, userExternalId, userName, url, planoUsuario, perfilUsuario, userUuid) {
    return AxiosConfig.eventosAPI().post('/v1/event', { event: event, source_system: sourceSystem, source_url: sourceUrl, user_email: userEmail, user_external_id: userExternalId, user_name: userName, metadata: { url: url, plano: planoUsuario, perfil: perfilUsuario }, user_uuid: userUuid }).then(response => response.data)
  }

}
